module.exports = __webpack_public_path__ + "img/skywind.140f4009.jpg";